import { createClient } from '@/shared/api';
import type {
  UpdateClinicNotificationsInput,
  UpdateClinicNotificationsMutation,
  UpdateClinicNotificationsMutationVariables,
} from '@/shared/api';
import UPDATE_CLINIC_NOTIFICATIONS_MUTATION from '../mutations/updateClinicNotifications';

/**
 * Applies an update to clinic notifications, such as flipping their read state. Runs the updateClinicNotifications mutation and throws the returned message when it does not report success.
 *
 * @param input - Mutation input describing the notification update.
 * @returns A promise resolving once the update has been applied.
 */
const handleUpdateClinicNotifications = async (input: UpdateClinicNotificationsInput) => {
  const client = createClient();
  const result = await client.mutate<
    UpdateClinicNotificationsMutation,
    UpdateClinicNotificationsMutationVariables
  >({
    mutation: UPDATE_CLINIC_NOTIFICATIONS_MUTATION,
    variables: { input },
  });
  const { data } = result;
  // pre-existing assumption: data is always present on this mutation's response
  const { updateClinicNotifications } = data!;
  if (!updateClinicNotifications?.isSuccess) {
    throw new Error(updateClinicNotifications?.message ?? undefined);
  }
};

export default handleUpdateClinicNotifications;
